import { ANALYTICS_CATEGORIES } from 'Services/analytics/analytics.const';

import { basePaymentsEvent } from './base/basePaymentEvent';
import type { PaymentEventProps } from './base/basePaymentEvent.type';

const {
	PAYMENTS: { NEGATIVE_EQUITY, PAYMENT },
} = ANALYTICS_CATEGORIES;

// eslint-disable-next-line local-rules/function-naming
export function vehiclePaymentEvents<CustomData extends UnknownShapeObject>(
	props: PaymentEventProps<CustomData>,
): void {
	basePaymentsEvent({
		category: PAYMENT,
		...props,
	});
}

export function triggerNegativeEquityEvents<CustomData extends UnknownShapeObject>(
	props: PaymentEventProps<CustomData>,
): void {
	basePaymentsEvent({
		category: NEGATIVE_EQUITY,
		...props,
	});
}
